import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Fetch orders
export const fetchOrders = createAsyncThunk(
  "orders/fetchOrders",
  async (page = 1, thunkAPI) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("userElqma"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.get(
        `${BASE_URL}/dashboard/order?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "فشل في جلب الأوردرات"
      );
    }
  }
);

// Fetch single order
export const fetchOrder = createAsyncThunk(
  "orders/fetchOrder",
  async (id, thunkAPI) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("userElqma"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.get(
        `${BASE_URL}/dashboard/order/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "فشل في جلب تفاصيل الأوردر"
      );
    }
  }
);

// Delete order
export const deleteOrder = createAsyncThunk(
  "orders/deleteOrder",
  async (id, thunkAPI) => {
    try {
      const storedUser = JSON.parse(sessionStorage.getItem("userElqma"));
      
      // محاولة الحصول على التوكن من أماكن مختلفة
      let token = storedUser?.token;
      if (!token) {
        token = storedUser?.data?.token;
      }
      if (!token) {
        token = storedUser?.user?.token;
      }

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.delete(
        `${BASE_URL}/dashboard/order/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          },
        }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "فشل في حذف الأوردر"
      );
    }
  }
);

const orderSlice = createSlice({
  name: "orders",
  initialState: {
    orders: [],
    currentOrder: null,
    pagination: null,
    isLoading: false,
    error: null,
    success: null,
    deleteSuccess: false,
    deleteLoading: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
      state.deleteSuccess = false;
    },
    clearCurrentOrder: (state) => {
      state.currentOrder = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Orders
      .addCase(fetchOrders.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.orders = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || action.payload || "فشل في جلب الأوردرات";
      })
      
      // Fetch Single Order
      .addCase(fetchOrder.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentOrder = action.payload.data;
      })
      .addCase(fetchOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || action.payload || "فشل في جلب تفاصيل الأوردر";
      })
      
      // Delete Order
      .addCase(deleteOrder.pending, (state, action) => {
        state.deleteLoading = action.meta.arg;
        state.error = null;
      })
      .addCase(deleteOrder.fulfilled, (state, action) => {
        state.deleteLoading = null;
        state.deleteSuccess = true;
        state.success = action.payload.message;
        // Remove order from the list
        state.orders = state.orders.filter(order => order.id !== action.meta.arg);
      })
      .addCase(deleteOrder.rejected, (state, action) => {
        state.deleteLoading = null;
        state.error = action.payload?.message || action.payload || "فشل في حذف الأوردر";
      });
  },
});

export const { clearState, clearCurrentOrder } = orderSlice.actions;
export default orderSlice.reducer;
